import "./GraphNode.css"
import React, { FunctionComponent } from "react"
import { Handle, NodeProps } from "reactflow"
import { GraphNodeData } from "@store/services/converter/types"
import { graphNodeSelectionStyle } from "./style/graphNodeSelectionStyle"
import NodeContainer from "@features/graph/node/NodeContainer"

export const DiscreteNode: FunctionComponent<NodeProps<GraphNodeData>> = (props) => {
  const data = props.data

  const target = props.targetPosition ? (
    <Handle type="target" position={props.targetPosition} isConnectable={props.isConnectable} />
  ) : (
    ""
  )
  const source = props.sourcePosition ? (
    <Handle
      type="source"
      id="a"
      position={props.sourcePosition}
      isConnectable={props.isConnectable}
    />
  ) : (
    ""
  )

  return (
    <>
      {
        <NodeContainer {...props}>
          <div
            className={graphNodeSelectionStyle(
              props.selected,
              props.id,
              data.display.exportExcluded,
            )}
            title={data.expression || ""}
          >
            {target}
            <div className="graph-node-type graph-node-discrete">{props.type}</div>
            <div className="graph-node-label">{data.display.label}</div>
            {source}
          </div>
        </NodeContainer>
      }
    </>
  )
}
